<template>
    <v-dialog
        v-model="dialog"
        content-class="create-content-dialog"
        persistent
    >   
        <div 
            class="create-content-dialog-container"
            @dragenter.prevent="dragEnter"
            @dragleave.prevent="dragLeave"
            @dragover.prevent
            @drop.prevent
        >
            <v-form @submit.prevent>       
                <h3 class="--green"> {{ headings.heading }} </h3>
                <hr>
                <div>
                    <v-textarea 
                        counter outlined 
                        :placeholder="headings.placeholder" 
                        v-model="broadcastdata.message"
                        maxlength="500"
                        :rules= "appliedRules"
                    > 
                    </v-textarea>
                    <p v-if="showerror" class="error_msg">* This field is required</p>
                    <br>
                    <input 
                        type="file"
				    	id="broadcast-image-uploader"
				    	style="display: none"
				    	multiple
				    	accept="image/*"
                        
                        @change="selectImages"
                    />
                    <label
                        v-if="headings.type === 'whatsapp' || headings.type === 'krishify_chat' || headings.type === 'chatdirect'"
						for="broadcast-image-uploader" 
						class="flex upload-image --green pointer"
					>
						<img src="@/assets/MainDashboard/CreateContent/CreatePost/UploadImage.svg"/>
						Upload Images from your computer
					</label>

				    <div 
                        v-if="headings.type === 'whatsapp' || headings.type === 'krishify_chat' || headings.type === 'chatdirect'" 
                        class="flex drop-zone" 
                        @drop.prevent="dropImages"
                    >
				        <p>Drag and drop your image here </p>
                        <p>.jpg files supported </p>
                        <div class="images-preview-container flex">
						    <div
						    	v-for="(image, index) in imagePreviews"
						    	:key="index"
						    >   
						    	<img
						    		class="preview-image"
						    		:src="image.url"
						    	/>
						    	<v-icon
						    		class="delete-image pointer"
						    		color="white" size="22"
						    		@click.passive="removeSelectedImage($event, index)"
						    	>
						    		mdi-close
						    	</v-icon>
						    </div>
						</div>
				    </div>
                    <small> {{ headings.note }} </small>

                    <div class="buttons-section flex mt-3">
                        <button
                            @click="handleclose()"
                            class="cancel"
                            v-ripple>
                            Cancel
                        </button>
                        <button
                            v-if="headings.type === 'krishify_chat'"
                            @click="handleImageSubmit()"
                            class="approval white--text bold"
                            v-ripple>
                            Broadcast Now
                        </button>
                        <button
                            v-else-if="headings.type === 'chatdirect'"
                            @click="handleImageSubmit()"
                            class="approval white--text bold"
                            v-ripple>
                            Send message
                        </button>
                        <button
                            v-else-if="headings.type === 'whatsapp'"
                            @click="handleImageSubmit()"
                            class="approval white--text bold"
                            v-ripple>
                            Request for approval
                        </button>
                        <button
                            v-else
                            @click="handleSubmit()"
                            class="approval white--text bold"
                            v-ripple>
                            Request for approval
                        </button>
                    </div>
                </div>

                <v-progress-linear
					indeterminate
					class="mt-1"
					color="#1F8F58"
					v-if="sending"
				></v-progress-linear>
            </v-form>
            <success :type="headings.type" :dialog="submittedevent" @close="submittedevent = false"/>
        </div>
    </v-dialog>
</template>


<script>
import broadcastSuccessModal from "./success-modal.vue";
import helper from "../../../../helpers/methods";
import accessToken from '../../../../helpers/accessToken';
import API_URL from "../../../../helpers/apiUrls";
import xml2js from 'xml2js';
import rules from "../../../../helpers/rules";
import { mapActions } from "vuex";

export default {
    ...mapActions("StateFilterStore", ['addstatedata','GET_STATE_ID']),
    name : 'broadcastModal',
    data() {
        return {
            submittedevent: false,
            imagePreviews: [],
            imageSelectionLimit: 4,
            images: [],
            isDragged: false,
            fileupload: true,
            bucketName: "",
            expiryTime: "",
            bucketPath: "",
            uploadConfigs: {},
            presignedUrl:"",
            presignedFields:{},
            x_amz_algorithm:"",
            x_amz_credential:"",
            x_amz_date:"",
            x_amz_signature:"",
            policy:"",
            key:"",
            broadcastdata:{
                business_id:"",
                message:"",
                contents:[],
                broad_casting_users:{
                    state_ids:[]
                },
                broadcast_type: "",
            },
            sending: false,
            broadcastdialog: this.dialog,
			rules: rules,
			appliedRules: [],
            showerror: false,
            storedata: [],
        }
    },

    props : {
        dialog : {
            type : Boolean
        },
        headings : {
            type : Object
        }
    },

    watch:{
        dialog:function(){
            this.getbroadcastconfig(); 
            this.getStoredata();  
        },
    },

    methods:{
        getStoredata(){
            this.storedata = this.$store.getters['StateFilterStore/GET_STATE_ID'];
        },
        handleclose(){
            this.sending = false;
            this.showerror = false;
            this.$emit('close');
            this.clearallFields();
        },
        clearallFields(){
            this.imagePreviews = [],
            this.images = [],
            this.broadcastdata.message = "",
            this.broadcastdata.contents = [],
            this.broadcastdata.broad_casting_users = {},
            this.broadcastdata.broadcast_type = "",
            this.appliedRules = []
            this.broadcastdata.business_id = ""
        },
        getbroadcastconfig(){
            const successHandler = response => {
                if(response.status === 200) {
                    this.bucketName = response.data.configs.broadcast_image_upload_config.bucket_name;
                    this.expiryTime = response.data.configs.broadcast_image_upload_config.expiry_time;
                    this.bucketPath = response.data.configs.broadcast_image_upload_config.bucket_path;
                    this.imageSelectionLimit = Number(response.data.configs.broadcast_image_upload_config.maximum_number_of_images);
                }
            }
            const errorHandler = response => {
                this.showToast('Something went wrong internally!', 'error', 10000);
            }
            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : localStorage.getItem('Brand-ID') 
            }
            this.requestGET(
                API_URL.createContent__getImageOrVideoConfigs,
                {},
                headers,
                successHandler,
                errorHandler,
               
            )            
        },
        mounted(){
            console.log("THIS MOUNTED");
        },
        sendMessageData(){
            if(this.broadcastdata.message === ""){
                this.showerror = true
                this.sending = false; 
            } else {
                this.showerror = false;
                this.sending = true; 
            
            this.broadcastdata.broad_casting_users.state_ids = this.storedata;

            if(this.headings.type === "chatdirect"){              
                this.broadcastdata.broadcast_type = "krishify_chat";            
            } else {
                this.broadcastdata.broadcast_type = this.headings.type;
            }
            
            this.broadcastdata.business_id = accessToken.getCredentials().brandID
			const successHandler = (response) => {
                console.log(response);
                if (response.status === 200) {
                    this.sending = false;
                    if(response.data.status){
                        console.log(response);
                        this.sending = false;
                        this.submittedevent=true;
                        this.$emit('close');
                        this.clearallFields();
                    } else {
				        this.showToast(
					    "Something went wrong internally, Cannot broadcast message...",
					    "error",
					    10000
				        );   
                        this.sending = false;
                        this.broadcastdialog = false;   
                        this.clearallFields();                  
                    }
                } else {
				    this.showToast(
					"Something went wrong internally, Cannot broadcast message...",
					"error",
					10000
				    );   
                    this.sending = false;
                    this.broadcastdialog = false;   
                    this.clearallFields();                     
                }				
			};
            
			const errorHandler = (error) => {
				this.showToast(
					"Something went wrong internally, Cannot broadcast message...",
					"error",
					10000
				);      
				console.log(error);
			};
            console.log("DATAFOR API ", this.broadcastdata);
			this.newRequestPOST(
                `${API_URL.intent_capture}`,
				this.broadcastdata,
				{},
				successHandler,
				errorHandler,
                process.env.VUE_APP_API_BASE_URL_DISCOVERY,
			);  
            }          
        },

        getPresignedURLs(index){
			const successHandler = (response) => {
				if (response.status === 200) {
                    this.x_amz_algorithm = response.data.presigned_url.fields["x-amz-algorithm"];
                    this.x_amz_credential = response.data.presigned_url.fields["x-amz-credential"];
                    this.x_amz_date = response.data.presigned_url.fields["x-amz-date"];
                    this.policy = response.data.presigned_url.fields.policy;
                    this.key = response.data.presigned_url.fields.key;
                    this.x_amz_signature = response.data.presigned_url.fields["x-amz-signature"];
                    this.presignedUrl = response.data.presigned_url.url
                    this.uploadImage(index)
				}
			};
            this.uploadConfigs.bucket_name = this.bucketName;
            this.uploadConfigs.expiry_time = this.expiryTime;
            this.uploadConfigs.bucket_path = this.bucketPath;

			const errorHandler = (error) => {
				this.showToast(
					"Something went wrong internally, aborting video upload...",
					"error",
					10000
				);
				console.log(error);
			};
            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
            }
			this.requestGET(
				API_URL.myfarmer__getPresignedURLs,
				this.uploadConfigs,
				headers,
				successHandler,
				errorHandler,
               
			);
        },

        uploadImage(index){
            const form = new FormData();
            form.append("success_action_status", 201)
            form.append("key", this.key);
            form.append("x-amz-algorithm", this.x_amz_algorithm);
            form.append("x-amz-credential", this.x_amz_credential);
            form.append("x-amz-date", this.x_amz_date);
            form.append("policy", this.policy);
            form.append("x-amz-signature", this.x_amz_signature);
            form.append("file", this.images[index]);

            var parser = new xml2js.Parser({
                trim: true,  
                explicitArray: true           
            });

			const successHandler = (response) => {
                var obj = {
                    "content_media_type" : "image",
                    "content" : "",
                }
                parser.parseString(response.data, function (err, result) {
                    obj.content = result.PostResponse.Location[0]
                });	

                this.broadcastdata.contents.push(obj)
                if(this.images.length === this.broadcastdata.contents.length){
                    this.sendMessageData()
                }

			};
			const errorHandler = (error) => {
				this.showToast(
					"Something went wrong internally, aborting video upload...",
					"error",
					10000
				);
				console.log(error);
			};
			this.requestAWSPOST(
				this.presignedUrl,
				form,
				{},
				successHandler,
				errorHandler
			);
        },

		dragEnter() {
			this.isDragged = true;
		},
		dragLeave() {
			this.isDragged = false;
		},
        handleImageSubmit(){  
            this.sending = true;  
            if(this.images.length === 0){
                this.sendMessageData();
            } else {
                this.handleupload();  
            } 
        },
        handleSubmit(){  
            this.sending = true;    
            this.sendMessageData();   
        },
        handleupload(){
            for(var i=0; i<this.images.length; i++){
                this.getPresignedURLs(i);  
            }
        },

        selectImages(event) {
            console.log('event',event)
            if (this.imagePreviews.length + 1 > 4){
				this.showToast(
					`You can only select 4 images for this post. Please try again!`,
					"error",
					10000
				);
            } else
             {
				Array.from(event.target.files).forEach((file) =>
					this.images.push(file)
				);
                const thumbnails = helper.provideImagePreviewURL(this.images);
                const newPreviewArray = thumbnails.map((thumbnail) => {
					return {
						id: null,
						url: thumbnail,
					};
				});
                
                this.imagePreviews = newPreviewArray
                event.target.value = "";
            }
            event.target.value=""
		},

        dropImages(event) {
				Array.from(event.dataTransfer.files).forEach((file) =>
					this.images.push(file)
				);
                const thumbnails = helper.provideImagePreviewURL(this.images);
                const newPreviewArray = thumbnails.map((thumbnail) => {
					return {
						id: null,
						url: thumbnail,
					};
				});
                
                this.imagePreviews = newPreviewArray
		},

		removeSelectedImage(event, index) {
            event.stopPropagation()
            // console.log("this.forms[form.index]", index);
			this.imagePreviews = this.imagePreviews.filter(
				(image) => image != this.imagePreviews[index]
			);
			this.images = Array.from(this.images).filter(
				(image) => image != this.images[index]
			);
		},
    },

    components : {
        "success" : broadcastSuccessModal
    },
}
</script>

<style lang="scss" scoped>
.create-content-dialog-container {
	background-color: white;
	font-family: Roboto;
	padding: 20px;
}
.loader{
    width: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content : center;
}
hr {
    margin: 15px 0;
    border: 0.5px solid #E3E3E3;
}

small {
    color: #C4C4C4;
}
.error_msg{
    color:#AF3131
}
.buttons-section {
	justify-content: space-between;
}
.upload-image {
	background: rgba(87, 215, 192, 0.05);
	width:100%;
    padding: 10px;
}
button {
	border-radius: 5px;
	font-size: 1rem;
	padding: 20px 0;
}
.success_send_section{
    min-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;

    p{
        align-self: center;
    }
    .success-msg{
        font-size: 1.5rem;
        color: #919191 ;
        margin: 20px auto;
    }
    .team-msg{
        color: #C4C4C4;
        
    }
}
.images-preview-container {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
}
.imagepreview{
    background-color: #1D8D56;
    z-index: 1;
}
.images-preview-container > div {
	width: 120px;
	height: 120px;
	border-radius: 3px;
	margin: 0 5px;
}
.preview-image {
	object-fit: cover;
	width: 100%;
	height: 100%;
}
.delete-image {
	background-color: rgba(53, 52, 52, 0.47);
	border-radius: 50%;
	transform: translate(90px, -125px);
}

.closebtn{
    width: 100%;
    background: rgba(49, 138, 54, 0.05);
    color: #1D8D56;
    padding: 12px;
    font-weight: 500;
    align-self: flex-end;
}
.icon{
    font-size: 6rem;
}
.cancel,
.approval {
	width: 49%;
}
.cancel {
    background: rgba(138, 49, 49, 0.05);
    color: #AF3131;
}
.approval {
    background: linear-gradient(90.11deg, #318535 0.09%, #36983B 98.77%);
    box-shadow: 1px 3px 3px rgba(46, 73, 50, 0.25);
}

.drop-zone {
	flex-direction: column;
	background: #fbfdfc;
	border: 1px dashed #dbdbdb;
	border-radius: 7px;
	margin: 10px 0px 20px;
	padding: 60px 0;
	color: #c2cbc3;
	position: relative;

	p {
		margin: 0;
	}
}
.clicktoupload{
    color: blue;
    text-decoration: underline;
    cursor: pointer;
}
</style>

<style lang="scss">
.create-content-dialog.v-dialog {
	width: 60%;
}
.create-content-input fieldset {
	color: white !important;
}
@media all and (min-width: 1500px) {
	.create-content-dialog.v-dialog {
		width: 50%;
	}
}
</style>